var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mwf-form"},[_c('div',{attrs:{"id":_vm.containerId}}),(_vm.config.useRecaptcha)?_c('ReCaptcha',{attrs:{"executeSwitch":_vm.executeSwitch,"submit":_vm.getToken}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }